import { ColumnDef } from "@tanstack/react-table";
import { AxiosError, AxiosResponse } from "axios";
import React, { useEffect, useState, useRef } from "react";
import DataTable2 from "shared/DataTable2";
import { Button } from "../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/Label";
import { Toaster } from "../../components/ui/toaster";
import { useToast } from "../../hooks/use-toast";
import { benefitGroup, Datum } from "../../interface/BenefitGroup";
import { BenefitGroupAxiosInstance } from "../../Network/BenefitGroupAxiosInstance";
import ListOfBenefitName from "../Shared/BenefitName";
import ListOfBenefitGroup from "../Shared/ListOfBenefitGroup";
import { Option } from "../../interface/Option";
import ListOfBenefitGroupType from "../Shared/BenefitGroupType";
import FileUpload from "Pages/uploadFile/BenefitGroup/BenefitGroup";
import useQaAutomationIds from "../../utils/useQaAutomationIds";

const BenefitGroup: React.FC = () => {
  useQaAutomationIds("benefit-group");
  // Main data state
  const [items, setItems] = useState<benefitGroup>({ result: [] });

  // Form states
  const [benefitGroups, setBenefitGroups] = useState<Option[]>([]);
  const [benefits, setBenefits] = useState<Option[]>([]);
  const [Name, setName] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [groupType, setGroupType] = useState<number | undefined>(0);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [editIndex, setEditIndex] = useState<null | number>(null);
  const [clearBenefit, setClearBenefit] = useState(false);
  const [clearBenefitGroup, setClearBenefitGroup] = useState(false);
  const [clearGroupType, setClearGroupType] = useState(false);
const [isActive, setIsActive] = useState<boolean>(true);
const [currentPage, setCurrentPage] = useState(0);
  // dialog for details
  const [selectedItem, setSelectedItem] = useState<Datum | null>(null);
const [viewDialogOpen, setViewDialogOpen] = useState(false);

  // Get token from localStorage
  const token = localStorage.getItem("token") || "";

  // Initialize toast
  const { toast } = useToast();

  // Fetch initial data on component mount
  useEffect(() => {
    fetchItems();
  }, []);

  // Clear form function
  const clear = () => {
    setName("");
    setGroupType(0);
    setDescription("");
    setBenefitGroups([]);
    setBenefits([]);
    setIsActive(true);
  };

const handleOpenDialog = (item: Datum) => {
  setSelectedItem(item);
  setViewDialogOpen(true);
};
const handleCloseDialog = () => {
  setViewDialogOpen(false);
  setSelectedItem(null);
};
  // Dialog control handlers
  const handleAddClick = () => {
    setEditIndex(null);
    clear();
    setIsDialogOpen(true);
  };

  const handleEditClick = (item: Datum) => {
    handleEdit(item);
    setIsDialogOpen(true);
  };

  // Handlers for form inputs

  const handleBenefitChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setBenefits(selectedOptions);
  };

  const handleBenefitGroupChange = (selectedOptions: Option[]) => {
    console.log("selected:", selectedOptions);
    setBenefitGroups(selectedOptions);
  };
  const handleGroupTypeChange = (value: number | undefined) => {
    setGroupType(value);
  };

  // API Functions
  const fetchItems = async (): Promise<void> => {
    try {
      const response: AxiosResponse<{ success: boolean; result: Datum[] }> =
        await BenefitGroupAxiosInstance.get("getBenefitGroup");
      setItems({ result: [...response.data.result].sort((a: any, b: any) => b.id - a.id) });

      console.log(response.data.result);
    } catch (error) {
      console.error("Error fetching items:", error);
      toast({
        title: "Error",
        description: "Failed to fetch Benefit Group",
        variant: "destructive",
      });
    }
  };

  
  const toggleActiveStatus = async (item: Datum) => {
  try {
    const Valuesbenefit = (item.benefits || []).map((b: any) => b.id ?? b);
    const ValuesBenifetgroup = (item.benefit_groups || []).map((g: any) => g.id ?? g);

    const updatedItem = {
      data: {
        name: item.name,
        description: item.description,
        benefits: Valuesbenefit,
        benefit_groups: ValuesBenifetgroup,
        group_type: item.group_type,
        is_active: !item.is_active,
        id: item.id,
      },
      token: token,
    };

    const response = await BenefitGroupAxiosInstance.put(
      `updateBenefitGroup`,
      updatedItem
    );

    if (response.data.success) {
      setItems((prevItems) => ({
        result: prevItems.result.map((i) =>
          i.id === item.id ? { ...i, is_active: !item.is_active } : i
        ),
      }));
      toast({
        title: "Success",
        description: `Status changed to ${!item.is_active ? "Active" : "Inactive"}.`,
      });
    }
  } catch (error: any) {
    toast({
      title: "Error",
      description: error.response?.data?.error || "An unexpected error occurred.",
      variant: "destructive",
    });
  }
};
  const addItem = async (): Promise<void> => {
    if (!Name.trim()) {
      toast({
        title: "Error",
        description: "Name is required and cannot be empty.",
        variant: "destructive",
      });
      return;
    }
    if (Name.trim().length < 3) {
      toast({
        title: "Error",
        description: "Name must be at least 3 characters long.",
        variant: "destructive",
      });
      return;
    }

    const Valuesbenefit = benefits.map((option) => option.value);
    const ValuesBenifetgroup = benefitGroups.map((option) => option.value);

    try {
      const newGroupArray = [
        {
          name: Name,
          description: description,
          benefits: Valuesbenefit,
          benefit_groups: ValuesBenifetgroup,
          group_type: groupType,
           is_active: isActive,
        },
      ];
      console.log(newGroupArray);
      const payload = {
        data: newGroupArray,
        token,
      };

      const response = await BenefitGroupAxiosInstance.post(
        "addNewBenefitGroup",
        payload
      );

      if (response.data.success) {
        fetchItems();
        clear();
        setIsDialogOpen(false);

        toast({
          title: "Success",
          description: "New Benefit Group Added Successfully.",
        });
      } else {
        // Handle errors from the response
        const errorMessage =
          response.data.errors?.[0]?.error ||
          response.data.message ||
          "Failed to add the group.";
        toast({
          title: "Error",
          description: errorMessage,
          variant: "destructive",
        });
        console.log(response.data);
      }
    } catch (error: AxiosError | any) {
      const errorMessage =
        error.response?.data?.errors?.[0]?.error ||
        error.response?.data?.message ||
        error.response?.data?.error ||
        "An unexpected error occurred.";
      toast({
        title: "Error",
        description: errorMessage,
        variant: "destructive",
      });
      console.error("Error adding benefit group:", error);
    }
  };

  const handleEdit = (item: Datum) => {
    setName(item.name);
    setDescription(item.description);
    setGroupType(item.group_type ?? undefined);

    //Convert or process BenefitGroups fields
    const BenefitGroupsData = Array.isArray(item.benefit_groups)
      ? item.benefit_groups.map((obj) =>
          typeof obj === "string" ? { id: 0, name: obj } : obj
        )
      : [];

    setBenefitGroups(
      BenefitGroupsData.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );
    //Convert or process Benefit fields
    const BenefitData = Array.isArray(item.benefits)
      ? item.benefits.map((obj) =>
          typeof obj === "string" ? { id: 0, name: obj } : obj
        )
      : [];

    setBenefits(
      BenefitData.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );
setIsActive(item.is_active);
    setEditIndex(item.id);
  };

  const updateItem = async (id: string | number): Promise<void> => {
    if (!Name.trim()) {
      toast({
        title: "Error",
        description: " Name is required and cannot be empty.",
        variant: "destructive",
      });
      return;
    }
    if (Name.trim().length < 3) {
      toast({
        title: "Error",
        description: " Name must be at least 3 characters long.",
        variant: "destructive",
      });
    }
    const Valuesbenefit = benefits.map((option) => option.value);
    const ValuesBenifetgroup = benefitGroups.map((option) => option.value);
    try {
      const updatedItem = {
        data: {
          name: Name,
          description: description,
          benefits: Valuesbenefit,
          benefit_groups: ValuesBenifetgroup,
          group_type: groupType,
           is_active: isActive,
          id: id,
        },
        token: token,
      };

      const response = await BenefitGroupAxiosInstance.put(
        `updateBenefitGroup`,
        updatedItem
      );

      if (response.data.success) {
        fetchItems();
        clear();
        setIsDialogOpen(false);
        toast({
          title: "Success",
          description: "Benefit Group updated successfully.",
        });
      }
    } catch (error: AxiosError | any) {
      toast({
        title: "Error",
        description:
          error.response?.data?.error || "An unexpected error occurred.",
        variant: "destructive",
      });
    }
  };
const handleDownload = (item: Datum) => {
  const rows = [
    "name;description;benefits;benefit_groups;group_type;total_ip;total_op;is_active"
  ];

  const benefits = item.benefits || [];
  const benefit_groups = item.benefit_groups || [];
 

  const maxLen = Math.max(benefits.length, benefit_groups.length);

  // First row includes description and is_active
  if (maxLen > 0) {
    const benefit = benefits.length > 0 ? benefits[0].name  || "" : "";
    const benefitgroups = benefit_groups.length > 0 ? benefit_groups[0].name || "" : "";
    
    rows.push(
      `${item.name || ""};${item.description || ""};${benefit};${benefitgroups};${item.group_type || ""};${item.total_ip || ""};${ item.total_op || ""};${item.is_active ? "TRUE" : "FALSE"}`
    );

    // Subsequent rows exclude description and is_active
    for (let index = 1; index < maxLen; index++) {
            const benefit = index < benefits.length ? benefits[index].name || "" : "";
      const benefitgroups = index < benefit_groups.length ? benefit_groups[index].name || "" : "";

      rows.push(
        `${item.name || ""};;${benefit};${benefitgroups};`
      );
    }
  } else {
    rows.push(
      `${item.name || ""};${item.description || ""};${ item.group_type || ""};${ item.total_ip || "0"};${ item.total_op || "0"};${item.is_active ? "TRUE" : "FALSE"};`
    );
  }
//icd
  const csvContent = rows.join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `BenefitGroup_${item.id}.csv`;
  a.click();
  window.URL.revokeObjectURL(url);
};
  const removeItem = async (id: string | number): Promise<void> => {
    try {
      await BenefitGroupAxiosInstance.delete(`deleteBenefitGroup/${id}`, {
        data: { token: token },
      });
      fetchItems();
      toast({
        title: "Success",
        description: "Benefit Group Deleted Successfully.",
      });
    } catch (error) {
      console.error("Error removing item:", error);
      toast({
        title: "Error",
        description: "Failed to delete Benefit Group",
        variant: "destructive",
      });
    }
  };

  // Table Columns Configuration
 const columns: ColumnDef<Datum>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <Button
        variant="ghost"
        className="w-full justify-center"
        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
      >
        ID
        {column.getIsSorted() === "asc"
          ? " ↑"
          : column.getIsSorted() === "desc"
          ? " ↓"
          : ""}
      </Button>
    ),
 cell: ({ row }) => (
  <div className="w-full text-center font-medium">{row.index + 1}</div>
),
  },

  {
    accessorKey: "name",
    header: ({ column }) => (
      <Button
        variant="ghost"
        className="w-full justify-center"
        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
      >
        Name
        {column.getIsSorted() === "asc"
          ? " ↑"
          : column.getIsSorted() === "desc"
          ? " ↓"
          : ""}
      </Button>
    ),
    cell: ({ row }) => (
      <div className="w-full text-center">{row.getValue("name")}</div>
    ),
  },

  {
    accessorKey: "description",
    header: ({ column }) => (
      <Button
        variant="ghost"
        className="w-full justify-center"
        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
      >
        Description
        {column.getIsSorted() === "asc"
          ? " ↑"
          : column.getIsSorted() === "desc"
          ? " ↓"
          : ""}
      </Button>
    ),
    cell: ({ row }) => (
      <div className="w-full text-center">
        {row.getValue("description")}
      </div>
    ),
  },

  {
    accessorKey: "benefits",
    header: ({ column }) => (
      <Button
        variant="ghost"
        className="w-full justify-center"
        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
      >
        Benefits
        {column.getIsSorted() === "asc"
          ? " ↑"
          : column.getIsSorted() === "desc"
          ? " ↓"
          : ""}
      </Button>
    ),
    cell: ({ row }) => {
      const benefitIds = row.getValue("benefits") as {
        id: number;
        name: string;
      }[];
      return (
        <div className="w-full text-center">
          {Array.isArray(benefitIds)
            ? benefitIds.map((b) => b.name).join(", ")
            : benefitIds}
        </div>
      );
    },
  },
{
  accessorKey: "is_active",
  enableSorting: false,
  header: () => (
<div className="w-full text-center normal-case font-normal">Status</div>
  ),
  cell: ({ row }) => {
    const item = row.original;
    return (
      <div className="w-full flex justify-center">
        <button
          onClick={() => toggleActiveStatus(item)}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
            item.is_active ? "bg-green-500" : "bg-gray-300"
          }`}
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
              item.is_active ? "translate-x-6" : "translate-x-1"
            }`}
          />
        </button>
      </div>
    );
  },
}, 

  {
    id: "view",
    header: ({ column }) => (
      <Button
        variant="ghost"
        className="w-full justify-center"
        onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
      >
        View
        {column.getIsSorted() === "asc"
          ? " ↑"
          : column.getIsSorted() === "desc"
          ? " ↓"
          : ""}
      </Button>
    ),
    cell: ({ row }) => {
      const item = row.original;
      return (
        <div className="w-full flex justify-center py-2">
          <button
            onClick={() => handleOpenDialog(item)}
            className="text-blue-600 hover:text-blue-800"
            title="View Details"
          >
            <i className="fa-solid fa-eye text-lg"></i>
          </button>
        </div>
      );
    },
  },
];


  return (
<div className="h5-container mx-auto px-1 pt-16 pb-4" data-qa-page="benefit-group">
  <div className="flex justify-between items-center">
        <h5 className="mb-6 flex items-center gap-2 font-bold text-2xl mt-4 text-blue-900">
          <span className="icon-container flex items-center justify-center w-10 h-10 rounded-full bg-blue-900 text-white">
            <i className="fa-solid fa-users"></i>
          </span>
          Benefit Group{" "}
        </h5>

      </div>

      <DataTable2
        qaIdPrefix="benefit-group-data-table"
        columns={columns}
        data={items.result}
searchColumns={["name", "benefits"]}
searchPlaceholder="Search..."
searchHelpText="Benefit Group Name, Description, or Benefits."
        addButtonLabel="Add New Group"
        showAddButton={true}
        compactToolbar={true}
        toolbarUpload={<FileUpload fetchItems={fetchItems} />}
        pageIndex={currentPage}
        onPageChange={setCurrentPage}
        onEdit={handleEdit}
        onDelete={removeItem}
        onAdd={handleAddClick}
        onEditClick={handleEditClick}
        onDownload={handleDownload}
      />
 <Dialog open={viewDialogOpen} onOpenChange={(open) => { if (!open) handleCloseDialog(); }}>
  <DialogContent
    className="max-w-[720px] max-h-[92vh] flex flex-col p-0 overflow-hidden bg-white border-none rounded-2xl"
    style={{ boxShadow: "0 25px 60px rgba(0,0,0,0.18), 0 0 0 1px rgba(0,0,0,0.04)" }}
  >
    {selectedItem && (
      <>
        {/* ── Header ── */}
        <div style={{ background: "linear-gradient(135deg, #0f172a 0%, #1e3a8a 60%, #2563eb 100%)", padding: "24px 28px 20px", flexShrink: 0, position: "relative", overflow: "hidden" }}>
          <div style={{ position: "absolute", top: -40, right: -40, width: 160, height: 160, borderRadius: "50%", background: "rgba(255,255,255,0.04)" }} />
          <div style={{ position: "absolute", bottom: -30, left: -20, width: 100, height: 100, borderRadius: "50%", background: "rgba(255,255,255,0.03)" }} />
          <div style={{ display: "flex", alignItems: "flex-start", gap: 16, position: "relative", zIndex: 1 }}>
            <div style={{ width: 48, height: 48, borderRadius: 14, background: "rgba(255,255,255,0.12)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, fontWeight: 700, color: "#fff", flexShrink: 0, border: "1px solid rgba(255,255,255,0.1)" }}>
              {selectedItem.name?.charAt(0).toUpperCase() || "B"}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 2 }}>
                <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", margin: 0, letterSpacing: "-0.01em", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {selectedItem.name}
                </h2>
                <span style={{ display: "inline-flex", alignItems: "center", gap: 5, padding: "3px 12px", borderRadius: 9999, fontSize: 11, fontWeight: 600, flexShrink: 0, background: selectedItem.is_active ? "rgba(34,197,94,0.2)" : "rgba(239,68,68,0.15)", color: selectedItem.is_active ? "#86efac" : "#fca5a5", border: `1px solid ${selectedItem.is_active ? "rgba(34,197,94,0.25)" : "rgba(239,68,68,0.2)"}` }}>
                  <span style={{ width: 6, height: 6, borderRadius: "50%", background: "currentColor" }} />
                  {selectedItem.is_active ? "Active" : "Inactive"}
                </span>
              </div>
              <p style={{ fontSize: 12, color: "rgba(147,197,253,0.8)", margin: 0 }}>
                ID: <span style={{ fontWeight: 600, color: "#93c5fd" }}>#{selectedItem.id}</span>
                {selectedItem.description && <span style={{ marginLeft: 12, opacity: 0.7 }}>{selectedItem.description}</span>}
              </p>
            </div>
          </div>

          {/* Stats */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 10, marginTop: 18, position: "relative", zIndex: 1 }}>
            {[
              { icon: "fa-star", label: "Benefits", value: selectedItem.benefits?.length || 0, accent: "#60a5fa" },
              { icon: "fa-layer-group", label: "Benefit Groups", value: selectedItem.benefit_groups?.length || 0, accent: "#34d399" },
              { icon: "fa-bed-pulse", label: "Total IP", value: selectedItem.total_ip || 0, accent: "#a78bfa" },
              { icon: "fa-hospital", label: "Total OP", value: selectedItem.total_op || 0, accent: "#fb923c" },
            ].map((card, i) => (
              <div key={i} style={{ background: "rgba(255,255,255,0.07)", borderRadius: 12, padding: "12px 14px", border: "1px solid rgba(255,255,255,0.08)" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
                  <i className={`fa-solid ${card.icon}`} style={{ fontSize: 11, color: card.accent }} />
                  <span style={{ fontSize: 10, color: "rgba(147,197,253,0.7)", fontWeight: 500, letterSpacing: "0.06em" }}>{card.label}</span>
                </div>
                <span style={{ fontSize: 15, fontWeight: 700, color: card.accent }}>{card.value}</span>
              </div>
            ))}
          </div>
        </div>

        {/* ── Body ── */}
        <div style={{ overflowY: "auto", flex: 1, background: "#f8fafc", padding: "6px 0 16px" }}>

          {/* ─ Sub-Benefits ─ */}
          <div style={{ padding: "20px 28px 16px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
              <div style={{ width: 28, height: 28, borderRadius: 8, background: "#eff6ff", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid #dbeafe" }}>
                <i className="fa-solid fa-star" style={{ fontSize: 12, color: "#3b82f6" }} />
              </div>
              <span style={{ fontSize: 13, fontWeight: 700, color: "#0f172a" }}>Sub-Benefits</span>
            </div>
            <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", padding: "14px 16px", boxShadow: "0 1px 3px rgba(0,0,0,0.03)" }}>
              <div style={{ display: "flex", flexWrap: "wrap" as const, gap: 6 }}>
                {selectedItem.benefits && selectedItem.benefits.length > 0
                  ? selectedItem.benefits.map((b, i) => (
                      <span key={i} style={{ padding: "4px 12px", borderRadius: 9999, fontSize: 12, fontWeight: 500, background: "#eff6ff", color: "#1d4ed8", border: "0.5px solid #bfdbfe" }}>{b.name}</span>
                    ))
                  : <span style={{ color: "#94a3b8", fontSize: 12, fontStyle: "italic" }}>No benefits</span>}
              </div>
            </div>
          </div>

          <div style={{ height: 1, background: "#e2e8f0", margin: "0 28px" }} />

          {/* ─ Benefit Groups ─ */}
          <div style={{ padding: "20px 28px 16px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
              <div style={{ width: 28, height: 28, borderRadius: 8, background: "#f0fdf4", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid #bbf7d0" }}>
                <i className="fa-solid fa-layer-group" style={{ fontSize: 12, color: "#16a34a" }} />
              </div>
              <span style={{ fontSize: 13, fontWeight: 700, color: "#0f172a" }}>Benefit Groups</span>
            </div>
            <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", padding: "14px 16px", boxShadow: "0 1px 3px rgba(0,0,0,0.03)" }}>
              <div style={{ display: "flex", flexWrap: "wrap" as const, gap: 6 }}>
                {selectedItem.benefit_groups && selectedItem.benefit_groups.length > 0
                  ? selectedItem.benefit_groups.map((g, i) => (
                      <span key={i} style={{ padding: "4px 12px", borderRadius: 9999, fontSize: 12, fontWeight: 500, background: "#f0fdf4", color: "#15803d", border: "0.5px solid #bbf7d0" }}>{g.name}</span>
                    ))
                  : <span style={{ color: "#94a3b8", fontSize: 12, fontStyle: "italic" }}>No groups</span>}
              </div>
            </div>
          </div>

          <div style={{ height: 1, background: "#e2e8f0", margin: "0 28px" }} />

          {/* ─ Coverage Stats ─ */}
          <div style={{ padding: "20px 28px 16px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
              <div style={{ width: 28, height: 28, borderRadius: 8, background: "#fef3c7", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid #fde68a" }}>
                <i className="fa-solid fa-circle-dollar-to-slot" style={{ fontSize: 12, color: "#d97706" }} />
              </div>
              <span style={{ fontSize: 13, fontWeight: 700, color: "#0f172a" }}>Coverage & Settings</span>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
              {[
                { label: "Group Type", value: selectedItem.group_type ?? "—", icon: "fa-tag", color: "#6366f1" },
                { label: "Total IP", value: selectedItem.total_ip ?? "—", icon: "fa-bed-pulse", color: "#8b5cf6" },
                { label: "Total OP", value: selectedItem.total_op ?? "—", icon: "fa-hospital", color: "#f59e0b" },
              ].map((c, i) => (
                <div key={i} style={{ background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", padding: "14px 16px", boxShadow: "0 1px 3px rgba(0,0,0,0.03)" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 8 }}>
                    <div style={{ width: 22, height: 22, borderRadius: 6, background: `${c.color}15`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <i className={`fa-solid ${c.icon}`} style={{ fontSize: 10, color: c.color }} />
                    </div>
                    <span style={{ fontSize: 10, fontWeight: 600, color: "#64748b", letterSpacing: "0.04em" }}>{c.label}</span>
                  </div>
                  <span style={{ fontSize: 18, fontWeight: 700, color: c.color }}>{String(c.value)}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── Footer ── */}
        <div style={{ padding: "14px 28px", borderTop: "1px solid #e2e8f0", background: "#fff", display: "flex", alignItems: "center", justifyContent: "flex-end", flexShrink: 0 }}>
          <Button onClick={handleCloseDialog} style={{ background: "linear-gradient(135deg, #1e3a8a, #2563eb)", color: "#fff", fontWeight: 600, padding: "8px 28px", borderRadius: 10, boxShadow: "0 2px 8px rgba(37,99,235,0.3)" }}>Close Details</Button>
        </div>
      </>
    )}
  </DialogContent>
</Dialog>
   <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
  <DialogContent className="max-w-[680px] max-h-[88vh] flex flex-col p-0 overflow-hidden bg-white rounded-2xl">
    <DialogHeader className="px-6 pt-5 pb-4 border-b border-gray-200 bg-gray-50">
      <DialogTitle className="text-xl font-bold text-blue-900">
        {editIndex === null ? "Add Benefit Group" : "Edit Benefit Group"}
      </DialogTitle>
      </DialogHeader>

    <div className="flex-1 overflow-y-auto px-6 py-5 bg-white">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-1.5">
          <Label htmlFor="name" className="text-sm font-semibold text-gray-700">
            Name <span className="text-red-500">*</span>
          </Label>
          <Input
            id="name"
            value={Name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter name (minimum 3 characters)"
            className="h-10 border-gray-300 focus:border-blue-500 focus:ring-blue-500"
          />
        </div>

        <div className="space-y-1.5">
          <Label className="text-sm font-semibold text-gray-700">
            Group Type
          </Label>
          <ListOfBenefitGroupType
            onChange={handleGroupTypeChange}
            defaultValue={groupType}
            clear={clearGroupType}
          />
        </div>

        <div className="md:col-span-2 space-y-1.5">
          <Label htmlFor="Description" className="text-sm font-semibold text-gray-700">
            Description
          </Label>
          <Input
            id="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Enter description"
            className="h-10 border-gray-300 focus:border-blue-500 focus:ring-blue-500"
          />
        </div>

        <div className="space-y-1.5">
          <Label htmlFor="benefits" className="text-sm font-semibold text-gray-700">
            Sub-Benefit
          </Label>
          <ListOfBenefitName
            onChange={handleBenefitChange}
            defaultValue={benefits}
            clear={clearBenefit}
          />
        </div>

        <div className="space-y-1.5">
          <Label htmlFor="benefit_groups" className="text-sm font-semibold text-gray-700">
            Benefit Groups
          </Label>
          <ListOfBenefitGroup
            onChange={handleBenefitGroupChange}
            defaultValue={benefitGroups}
            clear={clearBenefitGroup}
          />
        </div>

        <div className="md:col-span-2 space-y-2">
          <Label className="text-sm font-semibold text-gray-700 block">
            Is Active
          </Label>
          <div className="grid grid-cols-2 gap-3 rounded-xl border border-gray-200 bg-gray-50 p-3">
            <button
              type="button"
              onClick={() => setIsActive(true)}
              className={`h-10 rounded-lg border text-sm font-semibold transition-all ${
                isActive
                  ? "bg-green-50 text-green-800 border-green-300 shadow-sm"
                  : "bg-white text-gray-500 border-gray-200 hover:bg-gray-100"
              }`}
            >
              Active
            </button>
            <button
              type="button"
              onClick={() => setIsActive(false)}
              className={`h-10 rounded-lg border text-sm font-semibold transition-all ${
                !isActive
                  ? "bg-red-50 text-red-800 border-red-300 shadow-sm"
                  : "bg-white text-gray-500 border-gray-200 hover:bg-gray-100"
              }`}
            >
              Inactive
            </button>
          </div>
        </div>
      </div>
    </div>

    <DialogFooter className="gap-2 px-6 py-4 border-t border-gray-200 bg-gray-50">
      <Button
        variant="outline"
        onClick={() => {
          setEditIndex(null);
          clear();
          setIsDialogOpen(false);
        }}
        className="border-gray-300 hover:bg-gray-100"
      >
        Cancel
      </Button>
      <Button
        onClick={() => {
          if (editIndex === null) {
            addItem();
          } else {
            updateItem(editIndex);
          }
        }}
        className="bg-blue-600 hover:bg-blue-700 text-white"
      >
        {editIndex === null ? "Add Relation " : "Update Relation "}
      </Button>
    </DialogFooter>
  </DialogContent>
</Dialog>
      <Toaster />
    </div>
  );
};

export default BenefitGroup;
